export const IconGiftFilled = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <path d="M14.049 21.805c0 .107.088.195.195.195h4.615c1.082 0 2-.897 2-1.96v-7.511a.196.196 0 0 0-.196-.195h-6.42a.196.196 0 0 0-.194.195zM3.151 19.844c0 1.19.966 2.156 2.156 2.156h4.459a.196.196 0 0 0 .195-.195v-9.276a.196.196 0 0 0-.195-.195h-6.42a.196.196 0 0 0-.195.195z" />
      <path d="M20.049 6.579h-1.893c.546-.985.527-2.205-.175-3.307-.469-.741-1.318-1.19-2.196-1.258-2.244-.156-2.975 1.19-3.775 3.18-.8-1.99-1.532-3.346-3.786-3.18-.946.068-1.834.595-2.292 1.424-.595 1.063-.595 2.204-.078 3.14H3.96A1.96 1.96 0 0 0 2 8.54v1.18a1.96 1.96 0 0 0 1.961 1.961h5.785a.216.216 0 0 0 .215-.214V6.793a.217.217 0 0 0-.215-.214h-1.18c-.907 0-1.62-.82-1.444-1.756.156-.858 1.132-1.395 1.96-1.122.596.205 1.386 1.024 1.533 2.868V21.99h2.77V6.58c.303-2.02.937-2.673 1.532-2.868.83-.283 1.795.263 1.961 1.122a1.472 1.472 0 0 1-1.444 1.755h-1.18a.217.217 0 0 0-.215.215v4.672c0 .117.098.215.215.215h5.785A1.96 1.96 0 0 0 22 9.73V8.548a1.96 1.96 0 0 0-1.961-1.96z" />
    </svg>
  );
};
